<template>
  <div style="width: 100%" v-if="currentSchool">
    <v-container class="px-md-8 py-md-5" fluid>
      <v-row class="justify-center">
        <v-col cols="12" sm="10">
          <v-row>
            <v-col cols="12">
              <v-data-table
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  :options.sync="options"
                  class="elevation-1"
                  loading-text="Traženje..."
                  :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
                  :header-props="{sortByText: 'Poredaj po'}">
                <template v-slot:[`item.actions`]="{ item }">
                  <!-- delete button for optional subject if exist -->
                  <v-row class="align-self-auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="
                    !item.official &&
                      $checkPermission('department enrollment delete document')
                  "
                            class="mx-1" x-small min-height="30"
                            outlined
                            color="error"
                            @click="openDelete(item)"
                        >
                          <v-icon
                              ripple small class="pa-0" color="error"
                          >
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Izbriši</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="
                                              !item.official &&
                      $checkPermission('department enrollment edit document')
                  "
                            class="mx-1" x-small min-height="30"
                            color="primary"
                            @click="openEdit(item)"
                        >
                          <v-icon
                              ripple small class="pa-0" color="white"
                          >
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Uredi</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="mx-1" x-small min-height="30"
                            color="primary"
                            target="_blank"
                            @click="goToDiploma(item)"
                        >
                          <v-icon
                              ripple small class="pa-0" color="white"
                          >
                            mdi-file-find
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Pregled</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if=" item.official && $checkPermission('demand create')"
                            class="mx-1" x-small min-height="30"
                            @click="openDemandDialog(item)"
                        >
                          <v-icon
                              ripple small class="pa-0" color="primary"
                          >
                            mdi-lock-open-alert-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Pošalji zahtjev za otključavanjem</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="
                          !item.official &&
                      $checkPermission('department enrollment lock document')
                  "
                            class="mx-1" x-small min-height="30"
                            color="error"
                            @click="openLock(item)"
                        >
                          <v-icon
                              ripple small class="pa-0" color="white"
                          >
                            mdi-lock
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Potvrdi</span>
                    </v-tooltip>
                  </v-row>
                </template>

                <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
                </template>
              </v-data-table>
            </v-col>

          </v-row>
        </v-col>

        <v-col
            cols="12"
            sm="2"
            v-if="
            $checkPermission('schools edit') ||
              $checkPermission('school_educational_field create')
          "
        >
          <v-btn
              v-if="$checkPermission('department enrollment edit document')"
              block
              depressed
              height="44"
              class="primary text-none mb-4"
              @click="openBestStudentDialog"
          >
            Odaberi učenika generacije
          </v-btn>
        </v-col>
      </v-row>
    </v-container>


    <v-dialog
        v-model="bestStudentDialog"
        width="1000"
        @click:outside="closeBestStudentDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Učenik generacije</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeBestStudentDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container class="pt-6">
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in items2"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>
                    <!--Label for the form-->
                    <v-col
                        cols="12"
                        md="3"
                        style="height: 44px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-2"
                      >
                        <span
                            class="font-weight-bold text--primary"
                            :style="{
                            color:
                              errors.length > 0
                                ? 'rgb(236 29 36) !important'
                                : '',
                            opacity: 0.8,
                            marginRight: '8px',
                          }"
                        >{{ item.title }}:</span
                        >
                      </div>
                    </v-col>
                    <!-- Text field -->
                    <v-col cols="12" md="9">
                      <v-text-field
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]"
                      >
                      </v-text-field>

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :search-input.sync="search"
                          :loading="isSearching"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          :item-value="item.value"
                          v-if="item.tag === 'select' && item.name==='department_enrollment_id'"
                          v-model="form[item.name]"
                      >
                      </v-autocomplete>

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :loading="isSearching"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          :item-value="item.value"
                          v-if="item.tag === 'select'&&item.name!=='department_enrollment_id'"
                          v-model="form[item.name]"
                      >
                      </v-autocomplete>

                      <!-- Date picker -->
                      <v-menu
                          v-model="item.model"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-if="item.tag === 'date'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              outlined
                              dense
                              :placeholder="item.rules ? 'Obavezno..' : ''"
                              v-model="form[item.name]"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]">
                        </v-date-picker>
                      </v-menu>

                      <v-menu
                              v-model="item.model"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                              v-if="item.tag === 'date1'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                                  outlined
                                  dense
                                  :placeholder="item.rules ? '..' : ''"
                                  v-model="form[item.name]"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                  depressed
                  class="text-none mb-3"
                  color="primary"
                  block
                  target="_blank"
                  :disabled="!form"
                  @click="saveBestStudent(bestStudent)"
              >
                Spremi
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title primary-title> Jeste li sigurni? </v-card-title>

        <v-card-text style="padding-top: 20px">
          Jeste li sigurni da želite obrisati posebnu diplomu učenik generacije?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" depressed large outlined
          >Odustani</v-btn
          >
          <v-btn @click="deleteStudentDocument()" color="error" depressed large
          >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="lockDialog"
        width="500"
        @click:outside="lockDialog = false"
    >
      <v-card>
        <v-card-title primary-title> Jeste li sigurni? </v-card-title>

        <v-card-text class="pt-5">
          Jeste li sigurni da želite potvrditi? <br />
          <span class="font-weight-bold">Upozorenje:</span>
          Kada potvrdite dokument više nećete imati mogućnost uređivanja.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="lockDialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani</v-btn
          >
          <v-btn
              color="error"
              @click="createOfficialDocument"
              class="text-none"
              depressed
              large
          >Potvrdi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="demandDialog"
        width="400"
        @click:outside="closeDemandDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Pošalji zahtjev</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeDemandDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="mt-6">
          <v-row>
            <v-col cols="12">
              <v-textarea
                  outlined
                  dense
                  auto-grow
                  v-model="demandReason"
                  rows="3"
                  label="Razlog"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="closeDemandDialog"
              class="text-none"
              depressed
              large
              outlined
          >Odustani</v-btn
          >
          <v-btn
              color="primary"
              class="text-none"
              @click="sendDemand"
              depressed
              large
          >Potvrdi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {extend, setInteractionMode, ValidationProvider} from "vee-validate";
import {digits, email, max, min, required} from "vee-validate/dist/rules";
import ApiV2 from "@/services/ApiV2";
import {serverBus} from "@/main";

export default {
  name: "SchoolBestStudents",
  components: {
    ValidationProvider,
  },
  data() {
    return {
      bestStudentDialog: false,
      form: {},
      demandDialog: false,
      deleteDialog: false,
      lockDialog: false,
      bestStudent: null,
      students: [],
      request:null,
      search: null,
      isSearching: false,
      demandReason: '',
      items: [],
      items2: [
        {
          data: "school_year_id",
          name: "school_year_id",
          options: "",
          rules: "required",
          source: [],
          text: "title",
          value: "id",
          tag: "select",
          type: "text",
          title: "Školska godina",
        },
        {
          data: "department_enrollment_id",
          name: "department_enrollment_id",
          options: "",
          rules: "required",
          source: [],
          text: "user.full_name",
          value: "id",
          tag: "select",
          type: "text",
          title: "Učenik",
        },
        {
          data: "date",
          name: "date",
          options: "",
          rules: "required",
          tag: "date",
          type: "date",
          title: "Datum izdavanja",
        },
        {
          data: "docket_number",
          name: "docket_number",
          options: "",
          rules: "required",
          tag: "input",
          type: "text",
          title: "Urudžbeni broj",
        },
        {
          data: "date_of_decision",
          name: "date_of_decision",
          options: "",
          rules: "",
          tag: "date1",
          type: "text",
          title: "Datum odluke nastavničkog vijeća",
        },

      ],
    };
  },
  computed: {
    headers() {
      return [
        {text: "Ime", value: "department_enrollment.user.first_name"},
        {text: "Prezime", value: "department_enrollment.user.last_name"},
        {text: "Datum izdavanja", value: "date"},
        {text: "Školska godina", value: "department_enrollment.department.school_year.title"},
        {text: "Akcije", value: "actions"},
      ];
    },
    currentSchool() {
      return this.$store.getters.getSchool;
    },
  },
  async created() {
    await this.getSchoolYears()
    await this.getDataFromApi()

    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", {...required, message: "Ovo polje je obavezno."});

  },
  methods: {
    async getSchoolYears() {

      let {data} = await ApiV2.get('school_years')
      this.items2[0].source = data.data;

    },
    goToDiploma(diploma) {
      let baseUrl = process.env.VUE_APP_SKOLE_API_URL;

      baseUrl = baseUrl + "v2/";

      window.open(`${baseUrl}files/${diploma.student_generation_file?.uuid}`, "_blank");
    },
    openDelete(item) {
      this.form = item
      this.deleteDialog = true;
    },
    openDemandDialog(item) {
      this.form = item
      this.demandDialog = true;
      this.demandReason = "";
    },

    closeDemandDialog() {
      this.form = {}
      this.demandDialog = false;
    },
    openLock(item) {
      this.form = item;
      this.lockDialog = true;
    },

    openEdit(diploma) {
      this.form = diploma;
      this.getStudents();
      this.bestStudentDialog = true;
    },
    async getDataFromApi() {

      let {data} = await ApiV2.get('student_of_generations', {
        params: {
          with: ['departmentEnrollment.user', 'departmentEnrollment.department.schoolYear', 'studentGenerationFile'],
          perPage: -1,
          filter: {school_id: this.currentSchool?.id}
        }
      })
      this.items = data.data;
    },

    saveBestStudent() {
      if (this.form.id){
        this.updateStudentDocument();
        return;
      }
      this.createStudentDocument()
    },
    openBestStudentDialog() {
      Object.assign(this.form, this.bestStudent);
      this.getStudents();
      this.bestStudentDialog = true;
    },
    closeBestStudentDialog() {
      this.bestStudentDialog = false;
      this.form = {};
      this.bestStudent = null;
    },
    async getStudents() {

      let {data} = await ApiV2.get('student_of_generations/get_possible_candidates', {
        params: {
          perPage: -1,
          search: this.search,
          school_id: parseInt(localStorage.getItem('school_id')),
          school_year_id: parseInt(localStorage.getItem('school_year_id'))
        }
      })

      this.items2[1].source = data.data
    },
    createStudentDocument() {
      this.form.school_id = parseInt(localStorage.getItem('school_id'));
      ApiV2.post(`student_of_generations`, this.form)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.getDataFromApi();
            this.closeBestStudentDialog();
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });
    },

    createOfficialDocument() {
      ApiV2.post(`student_of_generations/${this.form.id}/official`, {
        official: 1,
      })
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.getDataFromApi();
            this.form={}
            this.lockDialog = false;
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });

    },

    sendDemand() {
      const body = {
        demandable_type: "StudentOfGeneration",
        demandable_id: this.form.id,
        reason: this.demandReason,
        school_id: parseInt(localStorage.getItem('school_id')),
        column_name: "official",
      };

      ApiV2.post("demands", body)
          .then(() => {
            this.closeDemandDialog();
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    deleteStudentDocument() {
      ApiV2.delete(`student_of_generations/${this.form.id}`)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.getDataFromApi();
            this.form = {}
            this.deleteDialog = false;
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });

    },

    updateStudentDocument() {
      ApiV2.put(`student_of_generations/${this.form.id}`, this.form)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.getDataFromApi();
            this.closeBestStudentDialog()
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });

    },

  },
  watch: {
    currentSchool: function (newVal) {
      this.optimizeData();
      if (!newVal) {
        this.$router.push("/admin");
      }
    },

    search: {
      handler() {
        if (this.search !== null) {
          let self = this;

          self.loading = true;

          clearTimeout(self.request);

          self.request = null;
          self.request = setTimeout(function () {
            self.getStudents();
          }, 300);
        }
      },
      deep: true
    },



  },
};
</script>
